import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampAccommodationIcon: React.FC<SVGComponentProps> = ({
  width = 24,
  height = 24
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 11.975C4 11.425 4.19583 10.9583 4.5875 10.575C4.97917 10.1917 5.45 10 6 10V7C6 6.45 6.19583 5.97917 6.5875 5.5875C6.97917 5.19583 7.45 5 8 5H16C16.55 5 17.0208 5.19583 17.4125 5.5875C17.8042 5.97917 18 6.45 18 7V10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12V15.65C20 16.0333 19.8708 16.3542 19.6125 16.6125C19.3542 16.8708 19.0333 17 18.65 17L18.1 18.675C18.0667 18.775 18.0083 18.8542 17.925 18.9125C17.8417 18.9708 17.75 19 17.65 19H17.35C17.25 19 17.1583 18.9708 17.075 18.9125C16.9917 18.8542 16.9333 18.775 16.9 18.675L16.35 17H7.65L7.1 18.675C7.06667 18.775 7.00833 18.8542 6.925 18.9125C6.84167 18.9708 6.75 19 6.65 19H6.35C6.25 19 6.15833 18.9708 6.075 18.9125C5.99167 18.8542 5.93333 18.775 5.9 18.675L5.35 17C4.96667 17 4.64583 16.8708 4.3875 16.6125C4.12917 16.3542 4 16.0333 4 15.65V11.975ZM13 10H16V7H13V10ZM8 10H11V7H8V10ZM6 15H18V12H6V15Z"
        fill="#7F1D1D"
      />
    </svg>
  </SVGUniqueID>
);

export { BootcampAccommodationIcon };
